import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  createMemoryHistory,
} from "vue-router";
import IntroView from "../views/IntroView.vue";
import QuestionPreview from "../views/QuestionPreview.vue";

const router = createRouter({
  history: createMemoryHistory(),
  // history: createWebHashHistory(),
  // history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: IntroView,
    },
    {
      path: "/question-preview/:questionId(\\d+)",
      name: "question-preview",
      props: (route) => {
        return {
          ...route.params,
          ...{
            questionId: Number.parseInt(route.params.questionId),
          },
        };
      },
      component: QuestionPreview,
    },
    {
      path: "/segment-end/:segmentId(\\d+)",
      name: "segment-end",
      props: (route) => {
        return {
          ...route.params,
          ...{
            segmentId: Number.parseInt(route.params.segmentId),
          },
        };
      },
      component: () => import("../views/SegmentEndView.vue"),
    },
    {
      path: "/segment/:segmentId(\\d+)/question/:questionId(\\d+)",
      name: "segment-question",
      props: (route) => {
        return {
          ...route.params,
          ...{
            segmentId: Number.parseInt(route.params.segmentId),
            questionId: Number.parseInt(route.params.questionId),
          },
        };
      },
      component: () => import("../views/QuestionView.vue"),
    },
  ],
});

export default router;
